// A well's "phase" label. For a rig services company the well is a
// customer's well and the useful label is the work being done on it — the
// latest job's type (Workover, Drillout, P&A …), from the server's
// latestJobType. Otherwise the well's own phase.
export function wellPhaseLabel(t, well) {
  if (!well) return "";
  if (well.latestJobType) return t(`jobs.types.${well.latestJobType}`, { defaultValue: well.latestJobType });
  return well.current_phase ? t(`wells.phases.${well.current_phase}`, { defaultValue: well.current_phase }) : "";
}
